export const environment = {
    production: {
        //host: "http://localhost:5000",
        host: "https://bot-server.mcom.app",
        version: "v1"
    },
    dev: {
        host: "http://localhost:5000",
        version: "v1"
    }
}



// WEBPACK FOOTER //
// ./src/environments/index.jsx